var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.92 0 0 17.92 0 40s17.92 40 40 40 40-17.92 40-40S62.08 0 40 0zM29.16 57.16L14.8 42.8a3.983 3.983 0 010-5.64 3.983 3.983 0 015.64 0L32 48.68l27.52-27.52a3.983 3.983 0 015.64 0 3.983 3.983 0 010 5.64L34.8 57.16c-1.52 1.56-4.08 1.56-5.64 0z",
    fill: "#4CAF50"
  })));
}
export default SvgSuccessLarge;